import http from '../../axios-config/g-http-metodos';


function getAllAcessos() {
  const { res, erro, requisicao } = http.getArray("Acessos/getAllAcessos")
  return { GrupoArray: res , erro, requisicao }
}

function getAcessoByFiltro(acessoViewModel) {
    const { res, erro, requisicao } = http.postArray("Acessos/GetAcessoByFiltro", acessoViewModel)
    return { GrupoArray: res , erro, requisicao }
}

function postGrupoAcesso(arrayAcessos) {
  const { res, erro, requisicao } = http.postArray("Acessos/postGrupoAcesso", arrayAcessos)
  return { GrupoArray: res , erro, requisicao }
}

function postUsuarioAcesso(arrayAcessos) {
  const { res, erro, requisicao } = http.postArray("Acessos/postUsuarioAcesso", arrayAcessos)
  return { GrupoArray: res , erro, requisicao }
}

function getGruposAcessos(arrayAcessos) {
  const { res, erro, requisicao } = http.postArray("Acessos/getGruposAcessos", arrayAcessos)
  return { GrupoArray: res , erro, requisicao }
}


const AcessoController = {
  postGrupoAcesso,
  getAllAcessos,
  postUsuarioAcesso,
  getAcessoByFiltro,
  getGruposAcessos
}

export default AcessoController
